import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-fb70804c")
const _hoisted_1 = { class: "add-resource-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("种植品种")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("地区")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("面积")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "亩", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("上市时间")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("供应周期")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "天", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("预计产量")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "斤", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " "),
  /*#__PURE__*/_createTextVNode("照片")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " "),
  /*#__PURE__*/_createTextVNode("视频")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " "),
  /*#__PURE__*/_createTextVNode("备注")
], -1)
const _hoisted_14 = { class: "addbtn" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 提 交 ")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cascader = _resolveComponent("van-cascader")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_stcp_h5_uploader = _resolveComponent("stcp-h5-uploader")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_preview_video = _resolveComponent("preview-video")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_form, { onSubmit: _ctx.submit }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cell_group, null, {
          default: _withCtx(() => [
            (!_ctx.sourceId)
              ? (_openBlock(), _createBlock(_component_van_field, {
                  key: 0,
                  "is-link": "",
                  readonly: "",
                  modelValue: _ctx.varietyData,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.varietyData = $event)),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showVariety = true)),
                  name: "varietyData",
                  placeholder: "选择品种",
                  rules: [
            {
              required: true,
              trigger: 'onBlur',
              message: '请选择品种',
            },
          ]
                }, {
                  label: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            _createVNode(_component_van_field, {
              readonly: "",
              modelValue: _ctx.address,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.address = $event)),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showLocation = true)),
              name: "address",
              "right-icon": "location-o",
              placeholder: "选择省/市/区",
              rules: [
            {
              required: true,
              trigger: 'onBlur',
              message: '请选择地区',
            },
          ]
            }, {
              label: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_popup, {
              show: _ctx.showLocation,
              "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (_ctx.showLocation = $event)),
              round: "",
              position: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_cascader, {
                  title: "请选择所在地区",
                  options: _ctx.areaAllList,
                  "field-names": _ctx.fieldNames,
                  onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showLocation = false)),
                  onFinish: _ctx.onConfirmLocation
                }, null, 8, ["options", "field-names", "onFinish"])
              ]),
              _: 1
            }, 8, ["show"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.detail,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.detail = $event)),
              name: "detail",
              label: "详细地址",
              placeholder: "乡镇村等信息"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.area,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.area = $event)),
              name: "plantArea",
              type: "number",
              placeholder: "请输入",
              rules: [
            {
              required: true,
              trigger: 'onBlur',
              message: '请输入面积',
            },
          ]
            }, {
              label: _withCtx(() => [
                _hoisted_4
              ]),
              "right-icon": _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              "is-link": "",
              readonly: "",
              modelValue: _ctx.selectedDate,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectedDate = $event)),
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showDateDialog = true)),
              name: "launchDate",
              placeholder: "选择日期MM-DD",
              rules: [
            {
              required: true,
              trigger: 'onBlur',
              message: '请选择上市时间',
            },
          ]
            }, {
              label: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_popup, {
              show: _ctx.showDateDialog,
              "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => (_ctx.showDateDialog = $event)),
              round: "",
              position: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_datetime_picker, {
                  modelValue: _ctx.selectedMD,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectedMD = $event)),
                  onCancel: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showDateDialog = false)),
                  onConfirm: _ctx.confirmDate,
                  type: "month-day",
                  title: "选择月日",
                  formatter: 
              function (type, val) {
                if (type === 'month') {
                  return `${val}月`;
                }
                if (type === 'day') {
                  return `${val}日`;
                }
                return val;
              }
            
                }, null, 8, ["modelValue", "onConfirm", "formatter"])
              ]),
              _: 1
            }, 8, ["show"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.period,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.period = $event)),
              name: "supplyCycle",
              type: "number",
              placeholder: "请输入",
              rules: [
            {
              required: true,
              trigger: 'onBlur',
              message: '请输入周期',
            },
          ]
            }, {
              label: _withCtx(() => [
                _hoisted_7
              ]),
              "right-icon": _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.yieldNumber,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.yieldNumber = $event)),
              name: "yield",
              type: "number",
              placeholder: "请输入",
              rules: [
            {
              required: true,
              trigger: 'onBlur',
              message: '请输入产量',
            },
          ]
            }, {
              label: _withCtx(() => [
                _hoisted_9
              ]),
              "right-icon": _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              name: "uploader",
              label: "照片"
            }, {
              input: _withCtx(() => [
                _createVNode(_component_stcp_h5_uploader, {
                  modelValue: _ctx.imgList,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.imgList = $event)),
                  multiple: "",
                  "after-read": _ctx.afterRead,
                  onDelete: _ctx.delHeadIcon,
                  onPoster: _ctx.onClickImgPoster
                }, null, 8, ["modelValue", "after-read", "onDelete", "onPoster"])
              ]),
              label: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _createVNode(_component_van_field, {
              name: "uploader",
              label: "视频"
            }, {
              input: _withCtx(() => [
                _createVNode(_component_stcp_h5_uploader, {
                  modelValue: _ctx.videoList,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.videoList = $event)),
                  multiple: "",
                  "after-read": _ctx.afterReadVideo,
                  onDelete: _ctx.delHeadVideo,
                  onPoster: _ctx.onClickVideoPoster,
                  accept: "video/*"
                }, null, 8, ["modelValue", "after-read", "onDelete", "onPoster"])
              ]),
              label: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }),
            _createVNode(_component_van_field, {
              modelValue: _ctx.message,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.message = $event)),
              rows: "3",
              autosize: "",
              name: "remark",
              type: "textarea",
              placeholder: "请输入"
            }, {
              label: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_van_button, {
            block: "",
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"]),
    _createVNode(_component_van_popup, {
      show: _ctx.showVariety,
      "onUpdate:show": _cache[20] || (_cache[20] = ($event: any) => (_ctx.showVariety = $event)),
      round: "",
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cascader, {
          modelValue: _ctx.selectedVariety,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.selectedVariety = $event)),
          title: "选择品种",
          options: _ctx.varietyOptions,
          onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showVariety = false)),
          onChange: _ctx.onConfirmVariety,
          "field-names": { text: 'name', value: 'id', children: 'values' }
        }, null, 8, ["modelValue", "options", "onChange"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_preview_video, {
      visible: _ctx.showVideos,
      "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => (_ctx.showVideos = $event)),
      url: _ctx.videoUrl,
      autoplay: ""
    }, null, 8, ["visible", "url"])
  ]))
}